(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('facility-lab', {
                parent: 'entity',
                url: '/facility-lab',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN],
                    pageTitle: 'FacilityLabs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/facility-lab/list/facility-lab.html',
                        controller: 'FacilityLabController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();
